const users = [
	{
		id: 1,
		img: '../assets/userPageAssets/Ellipse0.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 2,
		img: '../assets/userPageAssets/Ellipse1.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 3,
		img: '../assets/userPageAssets/Ellipse2.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 4,
		img: '../assets/userPageAssets/Ellipse3.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 5,
		img: '../assets/userPageAssets/Ellipse4.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 6,
		img: '../assets/userPageAssets/Ellipse5.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 7,
		img: '../assets/userPageAssets/Ellipse6.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 8,
		img: '../assets/userPageAssets/Ellipse7.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 9,
		img: '../assets/userPageAssets/Ellipse8.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 10,
		img: '../assets/userPageAssets/Ellipse16.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 11,
		img: '../assets/userPageAssets/Ellipse11.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 12,
		img: '../assets/userPageAssets/Ellipse10.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 13,
		img: '../assets/userPageAssets/Ellipse12.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 14,
		img: '../assets/userPageAssets/Ellipse1.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 15,
		img: '../assets/userPageAssets/Ellipse5.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 16,
		img: '../assets/userPageAssets/Ellipse11.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 17,
		img: '../assets/userPageAssets/Ellipse15.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 18,
		img: '../assets/userPageAssets/Ellipse14.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 19,
		img: '../assets/userPageAssets/Ellipse10.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 20,
		img: '../assets/userPageAssets/Ellipse17.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 21,
		img: '../assets/userPageAssets/Ellipse7.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 22,
		img: '../assets/userPageAssets/Ellipse14.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 23,
		img: '../assets/userPageAssets/Ellipse1.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 24,
		img: '../assets/userPageAssets/Ellipse3.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},

	{
		id: 25,
		img: '../assets/userPageAssets/Ellipse21.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
	{
		id: 26,
		img: '../asssts/userPageAssets/Ellipse19.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},

	{
		id: 27,
		img: '../assets/userPageAssets/Ellipse20.png',
		userName: 'Ada Stevens',
		userStack: 'Senior Product Designer',
		followers: '1570',
		userFavoriteLanguage: 'sql, oracle, windows-options',
	},
];
export default users;
